import CardViewer from "../../elements/cardviewer";
import HomeSection from "../../elements/homeSection";
import { useTranslation } from 'react-i18next';

export default function PickingHomeCard() {

    const { t } = useTranslation();

    const getIncrementalDescriptions = () => {
        let descriptions = [];
        let i = 1;
        let desc;

        while ((desc = t(`home.primo_piano.picking.desc_${i}`)) && desc !== `home.primo_piano.picking.desc_${i}`) {
            descriptions.push(desc);
            i++;
        }

        return descriptions;
    };

    const descriptionList = getIncrementalDescriptions();
    return (
        <>
            <div className="perflex width100">
                <div className="perflex">
                    <div className="wow fadeInDown" data-wow-duration="2000ms">
                        <HomeSection
                            title={t("home.primo_piano.picking.title")}
                            imgSrcList={t('home.primo_piano.picking.dataImg', { returnObjects: true })}
                            descriptionList={descriptionList}
                            putBackground={true}
                            buttonText={t("home.primo_piano.picking.button")}
                            buttonLink="/picking"
                            backgroundColor={'white'}
                            flip={true}
                        >
                        </HomeSection>
                    </div>
                </div>
            </div>
        </>
    );
};
